import { useContext } from "react";
import BrandContext from "../contexts/BrandProvider";

const useBranding = () => {
  return useContext(BrandContext);
};

export default useBranding;
